/**
 * Allows optional rendering of props on a JSX element if the predicate is true. Usage:
 *
 *   <div {...optProp(author ? { 'data-author-id': author.id }) />
 *
 * It just simplifies what is otherwise a slightly ugly ternary expression.
 */
export const optProp = (predicate, props) => (predicate ? props : {})
